import script from "./m-index.vue?vue&type=script&setup=true&lang=js"
export * from "./m-index.vue?vue&type=script&setup=true&lang=js"

import "./m-index.vue?vue&type=style&index=0&id=181be873&scoped=true&lang=scss"
import "./m-index.vue?vue&type=style&index=1&id=181be873&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181be873"]])

export default __exports__